import React, { useState, useRef } from 'react'
import Alert from '@boltui/alert'
import { pushEventAndTrack } from '../../helpers/TaggingSerializer'

import styles from './StoreLocator.scss'

const StoreLocator = () => {
  const searchInputRef = useRef(null)
  const [validInput, isValidInput] = useState(true)

  const setInvalidInput = () => {
    searchInputRef.current.focus()
    isValidInput(false)
    setTimeout(() => isValidInput(true), 5000)
  }

  const trackClick = () => {
    const searchString = searchInputRef.current.value
    pushEventAndTrack({
      eventInfo: {
        eventName: 'hp_storeLocatorWidgetSearch',
        eventAction: 'Store Locator Widget Search',
      },
      attributes: {
        searchString,
      },
    })
  }

  const searchForStores = (event) => {
    event.preventDefault()
    const searchString = searchInputRef.current.value
    if (!searchString.length) return setInvalidInput()
    window.location.href = `//www.argos.co.uk/stores/search/${encodeURI(searchString)}`
    return true
  }

  return (
    <div className='container' data-test='store-locator'>
      <div className={styles['store-locator']}>
        <label htmlFor='searchbox'>
          <h4> Find your nearest store</h4>
        </label>

        <form>
          <input
            type='text'
            placeholder='My town or postcode is...'
            id='searchbox'
            name='search'
            aria-label='My town or postcode is...'
            data-test='store-locator-input'
            ref={searchInputRef}
          />

          <button
            data-test='store-locator-button'
            onClick={(event) => {
              trackClick(event)
              searchForStores(event)
            }}>
            Let's go!
          </button>
        </form>
      </div>
      {!validInput && (
        <Alert
          className={styles['store-locator-error']}
          data-test='store-locator-error'
          kind='error'
          isCloseable={true}
          useSentry={false}>
          Please enter a valid town or postcode
        </Alert>
      )}
    </div>
  )
}

export default StoreLocator
